import styled from 'styled-components'

import {
  TypeStyle,
  fromMd,
  timingSlow,
  timingSlower,
  untilMd,
  zIndexModal,
} from '@syconium/little-miss-figgy'

import {
  NextDialog,
  NextDialogBackdrop,
  NextDialogBody,
} from '../../../app/_components/dialogs/NextDialog.client'

export const Dialog = styled(NextDialog)`
  border-radius: 0;
  min-width: initial;
  width: 100%;
  max-width: 100%;
  height: 100%;
  max-height: 100%;
  overflow-y: auto;
  margin: 0;
  background: ${o => o.theme.color.fill.subtle};
  border-top: 1px solid ${o => o.theme.color.stroke.neutral.border.decoration.on.background};
  text-align: left;
  display: flex;
  flex-direction: column;

  /* Slide up animation (match legacy NextModal) */
  transform: translateY(24px);
  opacity: 0;
  transition:
    transform ${timingSlow} ease,
    opacity ${timingSlow} ease;

  &[data-enter] {
    transform: translateY(0);
    opacity: 1;
  }
`

export const DialogBody = styled(NextDialogBody)`
  padding: 0;
  height: 100%;

  ${fromMd} {
    padding: 0 ${o => o.theme.spacing(10)} ${o => o.theme.spacing(10)} ${o => o.theme.spacing(10)};
  }
`

const BACKDROP_TIMING = timingSlower
const DIALOG_TIMING = timingSlow
const BACKDROP_Z_INDEX = zIndexModal + 1

export { BACKDROP_TIMING, DIALOG_TIMING }

export const Backdrop = styled(NextDialogBackdrop)`
  padding: 0;
  align-items: flex-end;
  justify-content: center;
  z-index: ${BACKDROP_Z_INDEX};
  background-color: transparent;
  ${fromMd} {
    align-items: center;
  }
  overflow: hidden;
`
export const Title = styled.h1`
  ${TypeStyle.css.headlineSmall}
  text-transform: uppercase;
`

export const Subtitle = styled.h2`
  ${TypeStyle.css.bodyNano}
  padding: ${o => o.theme.spacing(2)} 0;
`

export const ImageHeader = styled.div`
  text-align: center;
  padding-bottom: ${o => o.theme.spacing(5)};

  ${untilMd} {
    display: none;
  }
`

export const Section = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  position: relative;
`

export const ImagePreviewWrap = styled.div`
  width: 100%;
  ${fromMd} {
    position: relative;
  }
`

export const Container = styled.div`
  display: flex;
  position: relative;

  ${untilMd} {
    flex-direction: column;
  }

  ${fromMd} {
    width: 100%;
    height: calc(100% - ${o => o.theme.spacing(16)});
  }
`
